import React, { type ChangeEvent } from "react";
import "./Switch.css";

interface SwitchType {
  checked: boolean;
  handleChange: (value: boolean) => void;
}

const Switch: React.FC<SwitchType> = ({ checked, handleChange }) => {
  function onChange(event: ChangeEvent<HTMLInputElement>) {
    event.stopPropagation();
    handleChange(!checked);
  }

  return (
    <label className="switch" style={{ marginRight: "3mm" }}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider round"></span>
    </label>
  );
};

export default Switch;
